import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const FloatingContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: 1;
`;

const FloatingShape = styled(motion.div)`
  position: absolute;
  background: ${props => props.color || 'rgba(255, 255, 255, 0.1)'};
  border-radius: ${props => props.shape || '50%'};
  width: ${props => props.size || '50px'};
  height: ${props => props.size || '50px'};
  left: ${props => props.left || '0%'};
  top: ${props => props.top || '0%'};
  filter: blur(1px);
`;

const FloatingElements = ({ section }) => {
  // Configuración específica para cada sección
  const sectionConfigs = {
    hero: [
      { color: 'rgba(255, 255, 255, 0.1)', shape: '50%', size: '60px', left: '10%', top: '20%' },
      { color: 'rgba(252, 134, 10, 0.1)', shape: '30%', size: '80px', left: '80%', top: '30%' },
      { color: 'rgba(67, 150, 204, 0.1)', shape: '50%', size: '40px', left: '30%', top: '70%' },
    ],
    features: [
      { color: 'rgba(252, 134, 10, 0.1)', shape: '50%', size: '70px', left: '20%', top: '30%' },
      { color: 'rgba(67, 150, 204, 0.1)', shape: '30%', size: '90px', left: '70%', top: '40%' },
      { color: 'rgba(255, 255, 255, 0.1)', shape: '50%', size: '50px', left: '40%', top: '60%' },
    ],
    about: [
      { color: 'rgba(67, 150, 204, 0.1)', shape: '30%', size: '80px', left: '15%', top: '25%' },
      { color: 'rgba(252, 134, 10, 0.1)', shape: '50%', size: '60px', left: '75%', top: '35%' },
      { color: 'rgba(255, 255, 255, 0.1)', shape: '30%', size: '70px', left: '30%', top: '65%' },
    ],
    gallery: [
      { color: 'rgba(255, 255, 255, 0.1)', shape: '50%', size: '90px', left: '10%', top: '20%' },
      { color: 'rgba(252, 134, 10, 0.1)', shape: '30%', size: '70px', left: '80%', top: '30%' },
      { color: 'rgba(67, 150, 204, 0.1)', shape: '50%', size: '50px', left: '35%', top: '75%' },
    ],
    testimonials: [
      { color: 'rgba(67, 150, 204, 0.1)', shape: '30%', size: '100px', left: '20%', top: '30%' },
      { color: 'rgba(252, 134, 10, 0.1)', shape: '50%', size: '60px', left: '70%', top: '40%' },
      { color: 'rgba(255, 255, 255, 0.1)', shape: '30%', size: '80px', left: '40%', top: '60%' },
    ],
    contact: [
      { color: 'rgba(252, 134, 10, 0.1)', shape: '50%', size: '70px', left: '15%', top: '25%' },
      { color: 'rgba(67, 150, 204, 0.1)', shape: '30%', size: '90px', left: '75%', top: '35%' },
      { color: 'rgba(255, 255, 255, 0.1)', shape: '50%', size: '60px', left: '30%', top: '65%' },
    ],
    download: [
      { color: 'rgba(255, 255, 255, 0.1)', shape: '30%', size: '80px', left: '10%', top: '20%' },
      { color: 'rgba(252, 134, 10, 0.1)', shape: '50%', size: '70px', left: '80%', top: '30%' },
      { color: 'rgba(67, 150, 204, 0.1)', shape: '30%', size: '90px', left: '35%', top: '75%' },
    ],
  };

  const shapes = sectionConfigs[section] || sectionConfigs.hero;

  return (
    <FloatingContainer>
      {shapes.map((shape, index) => (
        <FloatingShape
          key={index}
          {...shape}
          animate={{
            y: [0, -30, 0],
            x: [0, Math.random() * 30 - 15, 0],
            scale: [1, 1.2, 1],
            rotate: [0, 360, 0],
          }}
          transition={{
            duration: Math.random() * 3 + 2,
            repeat: Infinity,
            ease: "easeInOut",
            delay: Math.random() * 2,
          }}
        />
      ))}
    </FloatingContainer>
  );
};

export default FloatingElements; 